import { useEffect } from 'react'
import { getDocumentTeachStructure } from '../../../services/sDocumentTeach/documentTeach.service';
import { forEach } from 'lodash-es';

const useGetDocumentTeachStructure = (source, setSource) => {   
    const renderIcon = (iconName) => {
        return `<span style='display: inline-flex; align-items: center; margin-right: 5px;'>
                    <i class='ms-Icon ms-Icon--${iconName}' aria-hidden='true'></i>
                </span>`;
    }

    const transformToTreeSource = (folders) => {
        return folders.map((folder) => ({
            label: `${renderIcon('Folder')} ${folder.name}`,
            items: folder.subFolders ? transformToTreeSource(folder.subFolders) : []
        }));
    };
    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getDocumentTeachStructure();
                
                if (serviceResponse.data.succeeded) {
                    setSource && setSource(transformToTreeSource(serviceResponse.data.data))
                }
                else {
                    setSource && setSource([])
                }
            }
            catch (error) {
                setSource && setSource([])
            }
        }
        
        if (source === null) {
            getData()
        }
    }, [source, setSource]);
}

export {
    useGetDocumentTeachStructure
}

